/*
 * @Author: hzm
 * @Date: 2022-12-14 10:47:22
 * @Description:
 */
export const USER_IDENTITY = {
  /** 无账号 */
  NOUSER: 0,
  /** 内部采购 */
  PURCHASER: 1,
  /** 内部供应商 */
  SUPPLIER: 2,
  /** 总管理员 */
  HOST: 3,
  /** 子企业管理员 */
  COMPANYHOST: 4,
  /** 外部采购 */
  OUTPURCHASER: 5,
  // 外部供应商
  OUTSUPPLIER: 6
};



export const HOME_ROUTES = {
  HOME: "",
  COMPANYHOME: "enterpriseadmin",
  SHOPPLATHOME: "shopplat",
};

/** 商品上架状态 */
export const PRODUCT_AUDIT_STATUS = {
  /** 未提交 */
  NOTAUDIT: 0,
  /** 上架审核钟 */
  AUDTIING: 1,
  /** 审核通过 */
  AUDITPASS: 2,
  /** 审核拒绝 */
  AUDITREFUSE: 3,
};
/** 商品审核状态 */

/** 商品上下架 */

export const PRODUCT_SHELF_STATUS = {
  /** 下架 */
  NOTSHELF: 0,
  /** 上架 */
  SHELF: 1,
};

/** 售后单类型 */

export const AFTERORDER_TYPE = {
  /** 退货 */
  RETURNGOODS: 0,
  /** 换货 */
  CHANGEGOODS: 1,
  /** 补发 */
  REISSUEGOODS: 4,
};

/** 退货状态 */

export const AFTERORDER_STATUS = {
  /** 待审核 */
  WAITAPPROVE: 0,
  /**回填单号 */
  BACKFILLORDER: 1,
  /**退货中 */
  RETURNGOODS: 2,
  /**换货钟 */
  CHANGEGOODS: 3,
  /**补发中 */
  REISSUEGOODS: 9,
  /**完成订单 */
  FINISHORDER: 4,
  /**拒绝订单 */
  REFUSEORDER: 5,
  /**换货待确认收货 */
  CHANGEGOODSWAITCONFIRM: 6,
};

/** 消息读取状态 */
export const READSTATUS = {
  NOTREAD: 0,
  READ: 1,
};


/** 智电云商品审核状态  */

/** 商品上架状态 */
export const ZDY_PRODUCT_AUDIT_STATUS = {
  /** 未提交 */
  NOTAUDIT: 0,
  /** 上架审核钟 */
  AUDTIING: 1,
  /** 审核通过 */
  AUDITPASS: 2,
  /** 审核拒绝 */
  AUDITREFUSE: 3,
};

/** 供货状态 */
export const ZDY_PRODUCT_SUPPLY_STATUS = {
  /** 未供货 */
  NOTSUPPLY: 0,
  /** 已供货 */
  SUPPLY: 1,
};


/** 子订单状态 */

export const ORDER_ITEM_STATUS = {
  /**待付款 */
  WAITPAY: 0,
  /** 待发货 */
  WAITDELIVER: 1,
  /** 已发货 */
  DELIVERED: 2,
  /**已完成 */
  FINISH: 3,

  /**已取消 */
  CANCLED: 4,
  /**售后中 */
  AFTERSALE: 5,
  /** 退货完成 */
  RETURNFINISH: 6,
  /** 换货完成 */
  CHANGEFINISH: 7,
}


// 菜单模块
export const MENU_MODULE = {
  /** 采购前台 */
  PURCHASEFRONT: 1,
  /** 采购后台 */
  PURCHASEBACK: 0,

  /** 供应商前台 */

  SUPPLIERFRONT: 2,

  /** 经销商前台 */

  DISTRIBUTORFRONT: 3,

}


// 供应商审核状态
export const SUPPLIER_AUDIT_STATUS = {
  /** 未提交 */
  NOTAUDIT: 0,
  /** 审核通过 */
  AUDITPASS: 1,
  /** 审核拒绝 */
  AUDITREFUSE: 2,
};
